import * as appActions from "../store/actions/app";
import { useDispatch, useSelector } from "react-redux";
import { fileLimitError, fileSizeError } from "../constants/messages";
import { acceptFiles } from "../utilities/appUtilities";

export function useDocuments(documents, setDocuments, dispatchFunc = false) {
  const dispatch = useDispatch();
  const config = useSelector((state) => state.app.config);

  function handleDocuments(files, mode) {
    let runFiles = files;

    if (mode === "remove") {
      runFiles = documents.files.filter((i) => i !== files);
    } else {
      if (files.length + documents.files.length <= config.totalFileLimit) {
        runFiles = [...documents.files, ...files];
      } else {
        dispatch(appActions.setAlertModal(true, "error", fileLimitError));
        setTimeout(() => {
          dispatch(appActions.setAlertModal(false, ""));
        }, 5000);
        return;
      }
    }

    const accepted = acceptFiles(
      runFiles,
      documents,
      config.totalFileSizeLimit
    );

    if (accepted.accept) {
      if (dispatchFunc) {
        dispatch(setDocuments({ files: accepted.files, size: accepted.size }));
      } else {
        setDocuments({ files: accepted.files, size: accepted.size });
      }
    } else {
      dispatch(appActions.setAlertModal(true, "error", fileSizeError));
      setTimeout(() => {
        dispatch(appActions.setAlertModal(false, ""));
      }, 5000);
    }
  }
  return handleDocuments;
}

export default useDocuments;
